import styled, { css } from 'styled-components';
import DataTable from '@components/DataTable';
import { media } from '@simplywallst/ui-core';

export const DataTableSubHeader = styled('th')`
  ${({ theme }) => theme.typography.tiny}
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  text-align: right !important;
  font-weight: normal;
  &:last-child {
    padding-left: 8px;
  }
`;

interface DataTableSubValueProps {
  noData: boolean;
}

export const DataTableSubValue = styled('td')<DataTableSubValueProps>`
  ${({ theme }) => theme.typography.tiny}
  color: ${({ theme, noData }) => theme.color.whiteRGBA(noData ? 0.3 : 0.8)};
  text-align: right !important;
`;

const ColStyle = css`
  padding: ${({ theme }) => theme.x1spacePx}px 12px;
  text-align: right;
  &:first-child {
    text-align: left;
  }
`;

export const DataTableWrapper = styled('div')`
  & table {
    // Prevent the table from overflowing when its content is larger than its container
    table-layout: fixed;
  }

  // wrap text contents in table cells
  & table th {
    white-space: pre-wrap;
  }

  & table td {
    word-wrap: break-word;
    white-space: break-spaces;
  }
`;

export const TableWrapper = styled('div')`
  width: 100%;
  ${media.xsDown`
    width: max-content;
  `}
`;
export const EarningsForecastDataTable = styled(DataTable)`
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
  thead tr th {
    ${({ theme }) => theme.typography.tinyStrong};
    height: ${({ theme }) => theme.x4spacePx}px;
    background: ${({ theme }) => theme.color.darkerGray};
  }
  th {
    position: sticky;
    top: 0px;
    z-index: 1;
    ${ColStyle}
  }

  tr > td:not(:first-child) {
    text-align: right;
  }

  caption {
    text-align: left;
  }
`;

export const EarningsAndRevenueGrowthWrapper = styled('div')`
  ${media.mdUp`
    min-height: 472px;
  `}
  min-height: 410px;
`;

interface TableDataCellProps {
  darken?: boolean;
}
export const TableDataCell = styled('td')<TableDataCellProps>`
  ${({ theme, darken }) =>
    darken && `color: ${theme.color.mediumGrayRGBA(0.7)};`}

  white-space: nowrap;
  vertical-align: middle;
  ${ColStyle}
`;

export const FutureEstimateRow = styled('tr')`
  &&& {
    background: ${({ theme }) => theme.color.brand01RGBA(0.1)};
  }
`;
